import { Users, Sparkles, MapPin, Zap } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/portfolio/Reveal";

export default function WhyUs() {
  const { t } = useLanguage();
  return <section data-testid="why-us-section" className="studio-section bg-[#f5f7f8] border-t border-slate-200/70">
    <div className="studio-container">
      <Reveal className="max-w-xl mb-10"><p className="studio-eyebrow">{t("whyUs.subtitle")}</p><h2 className="studio-heading">{t("whyUs.title")}</h2></Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {[{ icon: Users, key: "team" }, { icon: Sparkles, key: "eco" }, { icon: MapPin, key: "marina" }, { icon: Zap, key: "fast" }].map(({ icon: Icon, key }, index) =>
          <Reveal key={key} delay={index * 0.05} className="border-t border-slate-300 pt-6">
            <Icon className="text-marine-600 w-6 h-6 mb-5" aria-hidden="true" />
            <h3 className="font-semibold text-navy-900 text-base mb-3">{t(`whyUs.reasons.${key}.title`)}</h3>
            <p className="text-sm text-slate-500 leading-relaxed">{t(`whyUs.reasons.${key}.desc`)}</p>
          </Reveal>)}
      </div>
    </div>
  </section>;
}